import { QUERY_KEYS } from '../constants/query-keys'

export const REDIRECT_TO_MAX_AGE = 60 * 30

const SAME_ORIGIN_BASE = 'https://redirect.invalid'

export function sanitizeRedirectTo(value?: string | null) {
  if (!value || !value.startsWith('/')) {
    return undefined
  }

  try {
    const url = new URL(value, SAME_ORIGIN_BASE)

    if (url.origin !== SAME_ORIGIN_BASE) {
      return undefined
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return undefined
  }
}

export function buildAuthHrefWithRedirect(
  authHref: string,
  redirectTo: string,
) {
  return `${authHref}?${QUERY_KEYS.redirectTo}=${encodeURIComponent(redirectTo)}`
}
